import Vue from "vue";
import VueRouter from "vue-router";
import store from "./../vuex/store";
import { getuserinfo } from "../request/api/user";
import routerM from "./m.js";
import routerPC from "./pc.js";
Vue.use(VueRouter);
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const ISMOBILE = function() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};
console.log(ISMOBILE());
const router = new VueRouter({
  routes: ISMOBILE() ? routerM : routerPC,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 前进后退
      return savedPosition;
    } else {
      // 如果不是通过上述行为切换组件，就会让页面回到顶部
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  store.state.showbg = false;
  let islogin = store.state.userInfo.loginName ? true : false;
  if (to.name != "login" && to.name != "register" && to.name != "forget") {
    getuserinfo({})
      .then((res) => {
        if (res.resultCode == 0) {
          store.state.userInfo = res.result.data;
          let showLeftMenu = to.meta.showLeftMenu || false;
          store.state.showLeftMenu = showLeftMenu;
          let showhead = to.meta.showhead || false;
          store.state.showhead = showhead;
          if (to.name == "mine") {
            store.state.menuactive = 0;
          }
          if (to.name == "editpwd") {
            store.state.menuactive = 1;
          }

          next();
        } else {
          store.state.userInfo = {};
          store.state.showLeftMenu = false;
          store.state.showbg = true;
          store.state.showhead = false;

          next("/login");
        }
      })
      .catch(() => {
        store.state.showLeftMenu = false;
        store.state.showhead = false;
        next("/login");
      });
  } else {
    //如果当前是登录判断是否已登录 如果已登录则直接
    if (islogin) {
      next("/");
    } else {
      store.state.showLeftMenu = false;
      store.state.showhead = false;
      store.state.showbg = true;
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js